export default __webpack_public_path__ + "static/media/choices2.7cb1eb07.webp";